import React from 'react';
// import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useNavigateWithId } from '../customHooks';

const BackButton = function ({ url = null }) {
  const navigate = useNavigateWithId();

  const onClickBack = () => {
    if(url !== null) navigate(url);
    else navigate(-1);
  };

  return (
    <a
      role="button"
      onClick={onClickBack}
      className="btn btBack"
      tabIndex={0}
    >
      前に戻る
    </a>
  );
};

BackButton.propTypes = {
  url: PropTypes.string,
};

BackButton.defaultProps = {
  url: null,
};

export default BackButton;
